// Normalizes the result of api/_init.js's makeApiRequest() into a consistent
// { data, status } / { error, status } shape for domain-layer callers.
export function unwrapEnvelope(response) {
  if (response.error) {
    const body = response.error?.response?.data
    return {
      error: body ?? response.error,
      status: response.status,
    }
  }

  const body = response.data
  const isEnveloped =
    body !== null &&
    typeof body === 'object' &&
    !Array.isArray(body) &&
    'status_code' in body &&
    'data' in body

  return {
    data: isEnveloped ? body.data : body,
    status: response.status,
  }
}
